import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { postAPI_Update_User } from '../../../../../../constants/APIs';
import EditUsersForm from './EditUsersForm';
import Validation from '../../../../../../components/Validation';

export default function UpdateUsersForm({ id }) {
  const [open,setOpen] = useState(false);
  const [msg,setMsg] =useState([]);
  const [isUpdating, setIsUpdating] = useState(false);
  const handleSubmit = (data) => {
    const formmatedData = {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      status: data.status,
      properties: data.properties,
      roles: data.roles,
      phoneNumber: data.phoneNumber,
      updater: 'admin',
      groupId: getGroupID(),
    };    
    AxiosAPI({
      method: 'put',
      url: `${postAPI_Update_User}/${id}`,
      data: formmatedData,
    }).then((res) => {
      if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
        && res.data.Messages !== null && res.data.Messages.length > 0) {
        setMsg(res.data.Messages);
        setOpen(true);
      }
      else {
      setTimeout(() => {
        window.location.reload();
      }, 300);
    }
  });
  };

  return (
    <div>
      <Button
        color="primary"
        size="sm"
        onClick={() => setIsUpdating(!isUpdating)}
      >
        Edit
      </Button>
      {isUpdating && (
        <EditUsersForm
          formLabel="Update the User"
          visible={isUpdating}
          toggle={() => {
            setIsUpdating(!isUpdating);
          }}
          id={id}
          submit={handleSubmit}
        />
      )}
      <Validation open={open} messages={msg} toggle={()=>{setOpen(!open)}}></Validation>
    </div>
  );
}

// UpdateRatePlansForm.propTypes = {
//   id: PropTypes.string.isRequired,
//   applicableAddOnsWithIdAndName: PropTypes.array.isRequired,
//   includedAddOnsWithIdAndName: PropTypes.array.isRequired,
//   applicablePromosWithIdAndName: PropTypes.array.isRequired,
// };
